const scriptCount = {
	data: {
		total: 26,
		complete: 24
	},
	errors: []
};

const scriptsDatesCount = {
	data: {
		total: 26,
		complete: 1
	},
	errors: []
};

export { scriptCount, scriptsDatesCount };
